export default function getSubmissionCallback(fn: Function, value: string) {
  return ({ zip: currentZip }: { zip: string }) => {
    if (!currentZip) fn(value);
  };
}
